import { Component } from 'react';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export default class TwoFactorTokenExpired extends Component {
  render() {
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx("p", {
        children: I18n.text(`login.twoFactor.recovery.error.tokenExpired`)
      })
    });
  }
}